<div id="table-versions-container">
  <div id="vehicle-equipments-container" class="bounce-in-left">
    <div class="accent-color"> Equipaggiamenti </div>
    <div *ngFor="let equip of vehicleEquipments">
      {{ equip.description }}
    </div>
  </div>

  <table cdk-table [dataSource]="dataSource" class="bounce-in-right">

    <ng-container *ngFor="let column of tableColumns" [cdkColumnDef]="column.columnDef">
      <!-- header -->
      <th mat-header-cell *cdkHeaderCellDef class="custom-table-headers vehicle-versions" (click)="onTableHeaderClick(column)">
        {{ column.header }}
      </th>
      <!-- celle -->
      <td mat-cell *cdkCellDef="let row" class="custom-table-cells">
        <mat-icon *ngIf="row[column.index].equipIsMatching"> done </mat-icon>
        <mat-icon *ngIf="!row[column.index].equipIsMatching" color="warn"> clear </mat-icon>
      </td>
    </ng-container>

    <tr cdk-header-row *cdkHeaderRowDef="tableDisplayedColumns"></tr>
    <tr cdk-row *cdkRowDef="let row; columns: tableDisplayedColumns;"></tr>

  </table>

</div>
